import { forwardRef, type InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface InputRadioProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  labelClassName?: string;
  containerClassName?: string;
  error?: string;
}

export const InputRadio = forwardRef<HTMLInputElement, InputRadioProps>(
  ({ label, size, onChange, labelClassName, className, containerClassName, id, error, required, ...props }, ref) => {
    const inputClasses = twMerge("radio radio-xs checked:bg-primary");
    const labelClasses = twMerge("label-text ml-2.5", labelClassName);
    const containerClasses = twMerge("label cursor-pointer relative", containerClassName);

    return (
      <label className={containerClasses} htmlFor={id}>
        <input type="radio" className={inputClasses} ref={ref} {...props} />
        <span className={labelClasses}>{label}</span>
        {error && <span className="absolute -bottom-5 text-error text-xs">{error}</span>}
      </label>
    );
  },
);
